// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__269ux","inner":"Icon_inner__2nP7h"};